/* eslint-disable import/prefer-default-export */
import { Typography } from '@mui/material';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import { Icon, Text } from '../../components/atoms';
import style from './PrescriptionsHeader.module.scss';

const cx = classNames.bind(style);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function PrescriptionsHeader({ openPrescriptions }: any) {
  const DivClasses = cx({ PrescriptionsHeaderDiv: true });
  const TitleDivClasses = cx({ PrescriptionsHeaderTitleDiv: true });
  const TitleTextClasses = cx({ PrescriptionsHeaderTitleText: true });
  const TextDivClasses = cx({ PrescriptionsHeaderTextDiv: true });
  const TextClasses = cx({ PrescriptionsHeaderText: true });

  return (
    <div className={DivClasses}>
      <Icon icon='checklist' size={70} />
      <div className={TitleDivClasses}>
        <Typography variant='h4' className={TitleTextClasses}>
          <FormattedMessage id='prescriptions.Title' />
        </Typography>
        <div className={TextDivClasses}>
          <div className={TextClasses}>
            <Text>
              <FormattedMessage id='openRecipes' />: {openPrescriptions}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
}
